import React, { useState, useEffect, useCallback } from "react";
import { instance } from "../../axios";
import {
  PageHeader,
  UiInput,
  UiButton,
  UiToggle,
  UiRichText,
  UiTextArea,
  UiRSelect,
  PageError,
  UiSelect,
  OverlayLoader,
  BgLoader,
} from "../../ui";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { NavLink, useNavigate, useParams, useLocation, Outlet, useOutletContext } from "react-router-dom";

import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { Helmet } from "react-helmet";
import { TbExternalLink } from "react-icons/tb";
import { VscLinkExternal } from "react-icons/vsc";
import Swal from "sweetalert2";
import MicrosoftLogo from "../../img/microsoft.svg";


export function SmsEmailSettings() {
  const [inner_loader, setInnerLoader] = useState(false);

  const [bg_loader, setBGLoader] = useState(false);
  const schema = yup.object().shape(
    {
      email_from: yup.string().required("This is required"),

      smtp_host: yup.string().nullable()
        .when("email_from", {
          is: 'custom',
          then: (rule) =>
            rule
              .required("This is required field"),
        }),

      encryption: yup.string().nullable()
        .when("email_from", {
          is: 'custom',
          then: (rule) =>
            rule
              .required("This is required field"),
        }),

      smtp_username: yup.string().nullable()
        .when("email_from", {
          is: 'custom',
          then: (rule) =>
            rule
              .required("This is required field"),
        }),

      smtp_password: yup.string().nullable()
        .when("email_from", {
          is: 'custom',
          then: (rule) =>
            rule
              .required("This is required field"),
        }),

      from_email: yup.string().email("Enter valid email").nullable()
        .when("email_from", {
          is: 'custom',
          then: (rule) =>
            rule
              .required("This is required field"),
        }),

      from_name: yup.string().nullable()
        .when("email_from", {
          is: 'custom',
          then: (rule) =>
            rule
              .required("This is required field"),
        }),

      smtp_port: yup.string().nullable()
        .when("email_from", {
          is: 'custom',
          then: (rule) =>
            rule
              .matches(/^[0-9]+$/, "Enter valid number")
              .required("This is required field"),
        }),

      email_profile: yup.string().nullable()
        .when("email_from", {
          is: 'microsoft',
          then: (rule) =>
            rule
              .required("Connect your Microsoft account to continue"),
        }),



    },
    []
  );
  const [state, setState] = useState({ count: 0 });
  const [loader, showLoader] = useState({});

  const fetchData = () => {
    setBGLoader(true)
    instance
      .get("/notification_settings")
      .then(function (response) {
        setBGLoader(false)
        setState({ ...state, ...response.data });
        //setEntry(response.data.settings.service);
        reset(response.data.settings)
      })
      .catch(function (error) { })
      .then(function () { });
  }
  useEffect(() => {
    fetchData()

    window.fbAsyncInit = function () {
      // JavaScript SDK configuration and setup
      window.FB.init({
        appId: '2244537659052417', // Facebook App ID
        cookie: true, // enable cookies
        xfbml: true, // parse social plugins on this page
        version: 'v16.0' //Graph API version
      });
    };
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

  }, []);



  var SaveSettings = (e) => {
    showLoader({ ...loader, loader: true });

    instance({
      method: "post",
      url: "/update_notification_settings",
      data: e,
      //headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        showLoader({ ...loader, loader: false });
        if (response.data.status == "error") {
          toast(response.data.msg, { type: "error" });
        }
        if (response.data.status == "success") {
          toast(response.data.msg, { type: "success" });
        }
      })
      .catch(function (response) { });
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    getValues,
    setValue,
    resetField,
    watch,
    unregister,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmitHandler = async (data) => {
    SaveSettings(data);
    //reset();
  };
  const handleExternalLogin = (e) => {

    setInnerLoader(true);
    const popname = window.open(e, "popname", "status=1,toolbar=0,resizable=0");
    if (popname) {
      popname.focus();
      const timer = setInterval(() => {
        if (popname.closed) {
          setInnerLoader(false);
          clearInterval(timer);
        }
      }, 1000);
    } else {
      setInnerLoader(false);
      window.location.href = e;
    }


  }

  window.popupCallback = function (str) {
    setBGLoader(true)
    instance
      .get("/integration_validate?type=microsoft&id=" + str)
      .then(function (response) {
        setBGLoader(false)
        if (response.data.status == "error") {
          toast(response.data.msg, { type: "error" });
        }
        if (response.data.status == "success") {
          fetchData();
          toast(response.data.msg, { type: "success" });
        }
      })
  };

  const encWatch = watch('encryption');
  const emailfromWatch = watch('email_from');
  const emailProfileWatch = watch('email_profile');


  useEffect(() => {
    if (encWatch == 'SSL') {
      resetField("smtp_port", { defaultValue: '465' })
    } else if (encWatch == 'TLS') {
      resetField("smtp_port", { defaultValue: '587' })
    } else if (encWatch == 'None') {
      resetField("smtp_port", { defaultValue: '25' })
    }
  }, [encWatch]);

  const smsbuyModal = useModal('buy-sms');


  const BuySMSModal = () => {

    smsbuyModal.show({}).then((res) => {
      fetchData();
    });



  }

  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} code={state.code} />
    )
  }





  return (
    <>

      <div>
        {state.settings ? (

          <div>
            {bg_loader == true ? <BgLoader /> : (
              <>





                <form onSubmit={handleSubmit(onSubmitHandler)} noValidate>

                  <div className="card card-default mb-4"><OverlayLoader visible={inner_loader ? true : false} />
                    <div className="card-header">Email Settings</div>
                    <div className="card-body">
                      <label className="form-label">Send Email From</label>
                      <div className="mb-3 mt-2 d-flex">

                        <div className="form-check mb-3 me-3">
                          <input type="radio" className="form-check-input" value='practive' name="email_from" id="success-outlined" {...register("email_from")} />
                          <label className="form-check-label" htmlFor="success-outlined">Practive Server</label>
                        </div>
                        <div className="form-check mb-3 me-3">
                          <input type="radio" className="form-check-input" value='microsoft' name="email_from" id="microsoft" {...register("email_from")} />
                          <label className="form-check-label" htmlFor="microsoft">Office 365 / Outlook</label>
                        </div>
                        <div className="form-check">
                          <input type="radio" className="form-check-input" value='custom' name="email_from" id="danger-outlined"  {...register("email_from")} />
                          <label className="form-check-label" htmlFor="danger-outlined">Custom SMTP</label>
                        </div>
                      </div>
                      {emailfromWatch == 'custom' ? (
                        <>

                          <UiInput
                            lcol="2"
                            icol="10"
                            label="SMTP Host"
                            type="text"
                            name="smtp_host"
                            message={errors.smtp_host?.message}
                            {...register("smtp_host")}
                          />
                          <UiSelect
                            lcol="2"
                            icol="10"
                            label="Encryption"
                            options={['SSL', 'TLS', 'None']}
                            name="encryption"
                            message={errors.encryption?.message}
                            {...register("encryption")}
                          />
                          <UiInput
                            lcol="2"
                            icol="10"
                            label="SMTP Port"
                            type="text"
                            name="smtp_port"
                            message={errors.smtp_port?.message}
                            {...register("smtp_port")}
                          />

                          <UiInput
                            lcol="2"
                            icol="10"
                            label="SMTP Username"
                            type="text"
                            name="smtp_username"
                            message={errors.smtp_username?.message}
                            {...register("smtp_username")}
                          />

                          <UiInput
                            lcol="2"
                            icol="10"
                            label="SMTP Password"
                            type="password"
                            name="smtp_password"
                            message={errors.smtp_password?.message}
                            {...register("smtp_password")}
                          />

                          <UiInput
                            lcol="2"
                            icol="10"
                            label="From Email"
                            type="email"
                            name="from_email"
                            message={errors.from_email?.message}
                            {...register("from_email")}
                          />
                          <UiInput
                            lcol="2"
                            icol="10"
                            label="From Name"
                            type="text"
                            name="from_name"
                            message={errors.from_name?.message}
                            {...register("from_name")}
                          />

                        </>
                      ) : emailfromWatch == 'microsoft' ? (
                        <>
                          <input type="hidden" name="email_profile" {...register("email_profile")} />
                          {emailProfileWatch ? (
                            <p className="">Connected to <b>{state.settings.email_profile}</b> <UiButton onClick={() => setValue('email_profile', '')} title="Disconnect" className="btn btn-outline-danger btn-sm ms-2" type="button" />
                            </p>
                          ) : <>
                            <p className="text-secondary">
                              Click the button below to sign in and connect your Microsoft 365 or Outlook account. This will allow you to securely send emails through your connected Microsoft account.
                            </p>

                            <div onClick={() => handleExternalLogin(state.oauth.microsoft)} className="c-pointer d-inline-block" >
                              <img src={MicrosoftLogo} style={{ width: '200px' }} />
                            </div>
                            {errors.email_profile?.message ? (
                              <div className="text-danger mt-2">
                                {errors.email_profile?.message}
                              </div>
                            ) : ''}

                          </>
                          }
                        </>
                      ) : ''}



                    </div>
                  </div>

                  <div className="card card-default mb-4">
                    <div className="card-header">SMS Settings</div>
                    <div className="card-body">
                      <span className="fs-4">SMS Credits: <b>{state.settings.sms_balance}</b></span>
                      <a className="btn btn-outline-primary btn-sm ms-3" onClick={() => BuySMSModal()}>Buy SMS</a>
                      <div className="mt-4">
                        <label className="form-label">Send SMS From</label>

                        <div className="mb-3 mt-2 d-flex">
                          <div className="form-check me-3">
                            <input type="radio" className="form-check-input" value="practive" name="sms" id="sms1" autoComplete="off" {...register("sms")} />
                            <label className="form-check-label" htmlFor="sms1">Practive Header</label>
                          </div>
                          <div className="form-check">
                            <input type="radio" className="form-check-input" value="custom" name="sms" id="sms2" autoComplete="off" disabled={state.settings.sender_id ? false : true} {...register("sms")} />
                            <label className="form-check-label" htmlFor="sms2">Your Own Header</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>




                  <UiButton loading={loader["loader"]} title="Save" />
                </form>
              </>
            )}
          </div>
        ) : <BgLoader />
        }
      </div >
    </>
  );
}



export default function NotificationSettings() {
  let { id } = useParams();
  const [state, setState] = useState({});
  const [loader, showLoader] = useState(false);


  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} code={state.code} />
    )
  }


  return (
    <>
      <Helmet>

        <title>
          Communication Settings | Practive
        </title>


      </Helmet>
      <div>
        <div>
          <PageHeader title='Communication Settings' parent="Settings" link="/settings">

          </PageHeader>


          <div className="tabs mb-3">

            <NavLink to="" end className="tab-itm">Email & SMS</NavLink>
            <NavLink to="whatsapp" className="tab-itm">WhatsApp</NavLink>
          </div>

          <Outlet context={[state, setState]} />


        </div>

        <OverlayLoader visible={loader} />

      </div>
    </>

  );
}

